import type { Middleware } from '@reduxjs/toolkit';
import type { UnassignedTasksDisplayDateRange } from '~/reducers/unassignedTasksDisplayDateRange';

interface PartialState {
    selectedDate: string;
    unassignedTasksDisplayDateRange: UnassignedTasksDisplayDateRange;
}

export const resetStateOnSelectedDateChangeMiddleware: Middleware<
    unknown,
    PartialState
> = (store) => (next) => (action) => {
    const RESETTING_ACTIONS: Record<string, boolean> = {
        'selectedDate/setSelectedDate': true,
        'selectedDate/resetSelectedDate': true
    };
    const REQUIRED_ACTION = {
        type: 'unassignedTasksDisplayDateRange/resetUnassignedTasksDateRange'
    };

    const result = next(action);

    if (RESETTING_ACTIONS[action.type]) {
        store.dispatch(REQUIRED_ACTION);
    }

    return result;
};
